import { weekDays } from "@ryde/shared";

export type TShiftTemplateFieldName = "regular" | "holidayEve" | "holiday";
export type TShiftTemplateType = "weekly" | "loop";

export interface IShiftDay {
  regular: number[];
  holidayEve: number[];
  holiday: number[];
}

export interface IShiftDayProps {
  value: IShiftDay;
  index: number;
  update: (index: number, value: IShiftDay) => void;
  remove: (index: number) => void;
  isRemoveEnabled?: boolean;
}

export const shiftTemplateEmptyRow: IShiftDay = {
  regular: [],
  holidayEve: [],
  holiday: [],
};

export const getEmptyTemplateLoop = (): IShiftDay[] => [shiftTemplateEmptyRow];
export const getEmptyTemplateWeek = (): IShiftDay[] =>
  weekDays.map(() => shiftTemplateEmptyRow);
